import * as React from "react"
import { Box, Badge } from "@mui/material";
import { TooltipSeeker } from "@ui-seeker/core";
import { formatPriceSymbol } from "@ui-seeker/utils";


export default function listPriceColumn() {
	return {
		name: 'myListPrice', label: 'List Price',
		options: {
			filter: false,
			customBodyRowRender: (value, { currency, currentPriceStock }) => <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
				{formatPriceSymbol(value, currency)}
			</Box>
		}
	}
}